<template>
  <div>
    <Header />
    <Contents />
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/private/Header";
import Footer from "../../components/layout/Footer.vue";
import Contents from "./components/Contents.vue";

export default {
  components: {
    Header,
    Footer,
    Contents,
  },
};
</script>

<!-- 
Incentio Colectivo
Organigrama Ministerio
Organigrama Servicios
Premios y Reconocimiento
Recursos Financiero -->


